module.exports = __webpack_public_path__ + "img/Logo_TecNM_Horizontal_Blanco.42688ee0.svg";